import { useEffect } from 'react';

// https://usehooks.com/useOnClickOutside/

export function useOnClickOutside(refs, handler) {
  let domNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
  useEffect(() => {
    const listener = event => {
      // Do nothing if clicking ref elements or their descendent elements
      const refsClicked = refs.map(item => {
        if (item.current && item.current.contains(event.target)) {
          return true;
        }
        return false;
      });
      if (refsClicked.some(item => item)) {
        return;
      }
      handler(event);
    };
    domNode.addEventListener('mousedown', listener);
    domNode.addEventListener('touchstart', listener);
    return () => {
      domNode.removeEventListener('mousedown', listener);
      domNode.removeEventListener('touchstart', listener);
    };
  },
  // Add ref and handler to effect dependencies
  // It's worth noting that because passed in handler is a new ...
  // ... function on every render that will cause this effect ...
  // ... callback/cleanup to run every render. It's not a big deal ...
  // ... but to optimize you can wrap handler in useCallback before ...
  // ... passing it into this hook.
  [refs, handler]);
}